<template>
  <div>
    <el-popover
      ref="popover"
      @show="showPopover = true"
      @hide="showPopover = false"
      v-model="showPopover"
      placement="bottom"
      width="450"
      trigger="click"
    >
      <el-input
        v-model="searchValue"
        v-loading="searchLoading"
        slot="reference"
        placeholder="请选择所在组织"
        :suffix-icon="showPopover ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
        readonly
      ></el-input>
      <el-tree
        style="max-height: 300px; overflow-y: auto"
        ref="rganizationSelectTree"
        :data="organizationList"
        accordion
        :props="{
          label: 'name',
          children: 'children',
        }"
        node-key="id"
        :expand-on-click-node="false"
        highlight-current
        default-expand-all
        check-on-click-node
        @node-click="handleNodeClick"
        :filter-node-method="filterNode"
        :default-checked-keys="
          selectOrganization ? [selectOrganization.id] : null
        "
        :current-node-key="selectOrganization ? selectOrganization.id : null"
      ></el-tree>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: "OrganizationTreeSelect",
  props: {
    value: {
      type: [Object],
      default: this.topNode,
    },
    containTopNode: {
      type: Boolean,
      default: false,
    },
    containFrozen: {
      type: Boolean,
      default: false,
    },
    parentData: [],
  },
  watch: {
    searchValue(val) {
      if (!this.showPopover || !val || val == "") {
        return;
      } else {
        this.$refs.organizationSelectTree.filter(val);
      }
    },
    value: {
      handler(val) {
        this.selectOrganization =
          val || (this.containTopNode ? this.topNode : null);
        this.searchValue = this.selectOrganization
          ? this.selectOrganization.name
          : null;
      },
      immediate: true,
    },
  },
  data() {
    return {
      searchValue: null,
      searchLoading: false,
      showPopover: false,
      organizationList: [],
      selectOrganization: null,
      topNode: null,
    };
  },
  methods: {
    async flushData() {
      this.searchLoading = true;
      this.topNode = await this.$jsTool.topOrganization();
      this.selectOrganization = this.topNode;
      let resData = [];
      if (this.parentData && this.parentData.length > 0) {
        resData = this.parentData;
      } else {
        let requestRes = this.containFrozen
          ? await this.$api.organization_findAllTree({
              showLoading: false,
            })
          : await this.$api.organization_findUnFrozenTree({
              showLoading: false,
            });
        if (requestRes && requestRes.success) {
          resData = requestRes.data;
        }
      }
      this.organizationList =
        resData && resData.length > 0
          ? this.containTopNode
            ? resData
            : resData[0].children
          : [];
      setTimeout(() => {
        this.searchLoading = false;
      }, 200);
    },
    handleNodeClick(e) {
      this.selectOrganization = e;
      this.$emit("nodeClock", e);
      this.showPopover = false;
    },
    filterNode(value, data) {
      if (!this.showPopover || !value || value == "") {
        return true;
      }
      return data.name.indexOf(value) > -1;
    },
  },
  mounted() {
    this.flushData();
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/OrganizationTreeSelect.vue